import type { Point, Rectangle } from "@lib/zod/deliverySchema";

function normalizeLng(lng: number): number {
    // Normalize longitude to [-180, 180)
    return ((lng + 180) % 360 + 360) % 360 - 180;
}

export function isInsideRectangle(point: Point, rectangle: Rectangle) {
    // Check if the rectangle has valid properties
    if (!rectangle.topLeft?.lat || !rectangle.topLeft?.lng ||
        !rectangle.bottomRight?.lat || !rectangle.bottomRight?.lng) {
        return false;
    }

    if (!point.lat || !point.lng) {
        return false;
    }

    const minLat = Math.min(rectangle.topLeft.lat, rectangle.bottomRight.lat);
    const maxLat = Math.max(rectangle.topLeft.lat, rectangle.bottomRight.lat);

    if (point.lat < minLat || point.lat > maxLat) {
        return false;
    }

    const west = normalizeLng(rectangle.topLeft.lng);
    const east = normalizeLng(rectangle.bottomRight.lng);
    const lng = normalizeLng(point.lng);

    // Antimeridian-crossing rectangle: west > east after normalization
    if (west <= east) {
        return lng >= west && lng <= east;
    } else {
        return lng >= west || lng <= east;
    }
} 